export const HALF_A_SECOND = 500;
export const FIVE_SECONDS_IN_MS = 5000;
export const ONE_SECOND_IN_MILISECONDS = 1000;
export const THREE_SECONDS_IN_MILISECONDS = 3000;
